module.exports = __webpack_public_path__ + "img/r2.919acb53.jpg";